import React from 'react';
import { MdClose } from 'react-icons/md'; // Importe o ícone

import { Modal, ModalProps, Button, CircularProgress } from '@mui/material'; // Importe o Button

import { Container, CloseIconContainer } from './styles'; // Importe o CloseIconContainer

interface IConfirmationModal extends ModalProps {
  onClose?: () => void;
  onConfirm: () => Promise<void> | void;
  buttonDisabled?: boolean;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<IConfirmationModal> = ({
  children,
  onClose,
  onConfirm,
  buttonDisabled,
  isLoading,
  ...rest
}: IConfirmationModal) => {
  return (
    <Modal {...rest}>
      <Container>
        <CloseIconContainer onClick={onClose}>
          <MdClose size={24} />
        </CloseIconContainer>

        {children}

        <Button variant="contained" color="primary" onClick={onConfirm} disabled={buttonDisabled}>
          {!isLoading ? 'Confirmar' : <CircularProgress color="inherit" size={24} />}
        </Button>
      </Container>
    </Modal>
  );
};

export default ConfirmationModal;
